import { Routes } from "@angular/router";

const _translationScope: string = "feature/administration-routes";

export const ADMINISTRATION_ROUTES: Routes = [
  {
    path: "minimum-wage/templates",
    data: {
      context: {
        breadcrumb: {
          "static": {
            translationInfo: {
              defaultText: "Mindestlohndokumente",
              token: "breadcrumb-label-minimum-wage-documents",
              scope: _translationScope
            }
          }
        }
      }
    }
  },
  {
    path: "reader-units",
    data: {
      context: {
        breadcrumb: {
          "static": {
            translationInfo: {
              defaultText: "Zutrittskontrolleneinheiten Übersicht",
              token: "breadcrumb-label-reader-units-overview",
              scope: _translationScope
            }
          }
        }
      }
    }
  },
  {
    path: "users",
    data: {
      context: {
        breadcrumb: {
          "static": {
            translationInfo: {
              defaultText: "Benutzerübersicht",
              token: "breadcrumb-label-user-overview",
              scope: _translationScope
            }
          }
        }
      }
    },
    children: [
      {
        path: ":userId",
        data: {
          context: {
            breadcrumb: { apiPath: "api/administration/authorization/users/{userId}" }
          }
        }
      }
    ]
  },
  {
    path: "master-data/categories",
    data: {
      context: {
        breadcrumb: {
          "static": {
            translationInfo: {
              defaultText: "Stammdaten Übersicht",
              token: "breadcrumb-label-master-data-overview",
              scope: _translationScope
            }
          }
        }
      }
    },
    children: [
      {
        path: ":categoryNumber/:resource/:idField/:viewField/:localizedName",
        data: {
          context: {
            breadcrumb: {
              "static": {
                translationInfo: {
                  defaultText: "{localizedName}",
                  token: "breadcrumb-label-localized-name",
                  scope: _translationScope
                }
              }
            }
          }
        },
        children: [
          {
            path: "entities/:entityName/:entityNumber",
            data: {
              breadcrumb: {
                "static": {
                  translationInfo: {
                    defaultText: "{entityNumber}",
                    token: "breadcrumb-label-entity-number",
                    scope: _translationScope
                  }
                }
              }
            }
          }
        ]
      }
    ]
  },
  {
    path: "customer/documents",
    data: {
      context: {
        breadcrumb: {
          "static": {
            translationInfo: {
              defaultText: "Unternehmens-Dokumente Übersicht",
              token: "breadcrumb-label-customer-documents-overview",
              scope: _translationScope
            }
          }
        }
      }
    }
  },
  {
    path: "user-overview",
    data: {
      context: {
        breadcrumb: {
          "static": {
            translationInfo: {
              defaultText: "Alle Nutzer Übersicht",
              token: "breadcrumb-label-all-users-overview",
              scope: _translationScope
            }
          }
        }
      }
    }
  }
];
